import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { PlusCircle, Save, Trash2 } from "react-feather";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import {
  FormProvider,
  useForm,
  useFieldArray,
  Controller,
} from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate } from "react-router-dom";
import { addMultiCpfPercentageValidation } from "core/Operations/ValidationSchema/MasterValidationSchema";
import Select from "react-select";
import Datatable from "core/pagination/datatable";
import AlertMessage from "Components/UI/AlertMessage";
import { useCpfTypesQuery } from "AppQuries/master/CpfType/get-all-cpf-types";
import { useInsertMultipleCPFPercentageMutation } from "AppQuries/master/CpfPercenatge/cpf-percentage";
const activeStatusOptions = [
  {
    label: "Enable",
    value: true,
  },
  {
    label: "No",
    value: false,
  },
];
const AddMultipleCPFPercentage = () => {
  const userData = useSelector(loggedInUser);
  const { data: residentials } = useCpfTypesQuery({
    companyCode: userData?.companyCode,
  });
  const navigate = useNavigate();
  const {
    mutate: addCpfContribution,
    isError,
    error,
  } = useInsertMultipleCPFPercentageMutation();

  const contributionOptions =
    residentials?.data
      ?.filter((r) => r.isActive === true)
      .map((r) => ({
        id: r.shortCode,
        label: r.description,
        value: r.shortCode,
      })) || [];

  const methods = useForm({
    defaultValues: { cpfPercentage: [] },
    resolver: yupResolver(addMultiCpfPercentageValidation),
  });

  const {
    handleSubmit,
    control,
    setValue,
    watch,
    formState: { errors, isSubmitted },
  } = methods;

  const { fields, append, remove } = useFieldArray({
    control,
    name: "cpfPercentage",
  });

  console.log(errors);

  const [message, setMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);

  const onSubmit = (payload) => {
    console.log(payload);
    const cpfPercentage = payload?.cpfPercentage || [];
    console.log(cpfPercentage);
    addCpfContribution(cpfPercentage, {
      onSuccess: (data) => {
        console.log(data);
        if (data === true) {
          setMessage("CPF Contribution Rate Added Successfully.");
          setShowSuccessToast(true);
          setTimeout(() => {
            navigate(`${all_routes.master}${all_routes.cpfPercentage}`);
          }, 1000);
        } else {
          setMessage(data?.[0]?.errorMessage || "Something went wrong.");
          setShowErrorToast(true);
        }
      },
      onError: (error) => {
        setMessage(error.message || "Something went wrong.");
        setShowErrorToast(true);
      },
    });
  };

  const addRowHandler = () => {
    append({
      companyCode: userData.companyCode,
      code: 0,
      cpftype: "",
      ageFrom: "",
      ageTo: "",
      salaryFrom: 0,
      salaryTo: 0,
      employeePercentage: "",
      employerPercentage: "",
      employeeCpfMaxCeiling: "",
      isActive: true,
      createUser: userData.userName,
      createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
    });
  };

  const columns = [
    {
      title: "Actions",
      width: 100,
      className: "action-table-data",
      render: (_, __, index) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <Link
            type="button"
            className="btn btn-sm me-2 p-2"
            onClick={() => remove(index)}
          >
            <Trash2 />
          </Link>
        </div>
      ),
    },
    {
      title: "Cpf Type",
      dataIndex: "cpftype",
      fixed: "left",
      width: 300,
      render: (_, __, index) => (
        <>
          <Controller
            name={`cpfPercentage[${index}].cpftype`}
            control={control}
            defaultValue={watch(`cpfPercentage[${index}].cpftype`)}
            render={({ field }) => (
              <Select
                {...field}
                options={contributionOptions}
                className={`select ${
                  errors?.cpfPercentage?.[index]?.cpftype ? "is-invalid" : ""
                }`}
                value={contributionOptions.find(
                  (option) => option.value === field.value
                )}
                onChange={(selectedOption) => {
                  field.onChange(selectedOption ? selectedOption.value : "");
                }}
                menuPortalTarget={document.body}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    fontSize: "12px",
                    width: "200px",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
              />
            )}
          />
          {errors?.cpfPercentage?.[index]?.cpftype && (
            <div className="invalid-feedback">
              {errors.cpfPercentage[index].cpftype.message}
            </div>
          )}
        </>
      ),
    },
    {
      title: "Age From",
      dataIndex: "ageFrom",
      width: 200,
      render: (_, __, index) => (
        <>
          <Controller
            name={`cpfPercentage[${index}].ageFrom`}
            control={control}
            render={({ field }) => (
              <input
                {...field}
                type="text"
                placeholder="Age From"
                className={`form-control ${
                  errors?.cpfPercentage?.[index]?.ageFrom ? "is-invalid" : ""
                }`}
                style={{ width: "150px" }}
              />
            )}
          />
          {errors?.cpfPercentage?.[index]?.ageFrom && (
            <div className="invalid-feedback">
              {errors.cpfPercentage[index].ageFrom.message}
            </div>
          )}
        </>
      ),
    },
    {
      title: "Age To",
      dataIndex: "ageTo",
      render: (_, __, index) => (
        <>
          <Controller
            name={`cpfPercentage[${index}].ageTo`}
            control={control}
            render={({ field }) => (
              <input
                {...field}
                type="text"
                placeholder="Age To"
                className={`form-control ${
                  errors?.cpfPercentage?.[index]?.ageTo ? "is-invalid" : ""
                }`}
                style={{ width: "150px" }}
              />
            )}
          />
          {errors?.cpfPercentage?.[index]?.ageTo && (
            <div className="invalid-feedback">
              {errors.cpfPercentage[index].ageTo.message}
            </div>
          )}
        </>
      ),
    },

    {
      title: "Employee Percentage",
      dataIndex: "employeePercentage",
      width: 200,
      render: (_, __, index) => (
        <>
          <Controller
            name={`cpfPercentage[${index}].employeePercentage`}
            control={control}
            render={({ field }) => (
              <input
                {...field}
                type="text"
                placeholder="Employee Percentage"
                className={`form-control ${
                  errors?.cpfPercentage?.[index]?.employeePercentage
                    ? "is-invalid"
                    : ""
                }`}
              />
            )}
          />
          {errors?.cpfPercentage?.[index]?.employeePercentage && (
            <div className="invalid-feedback">
              {errors.cpfPercentage[index].employeePercentage.message}
            </div>
          )}
        </>
      ),
    },

    {
      title: "Employer Percentage",
      dataIndex: "employerPercentage",
      width: 200,
      render: (_, __, index) => (
        <>
          <Controller
            name={`cpfPercentage[${index}].employerPercentage`}
            control={control}
            render={({ field }) => (
              <input
                {...field}
                type="text"
                placeholder="Employer Percentage"
                className={`form-control ${
                  errors?.cpfPercentage?.[index]?.employerPercentage
                    ? "is-invalid"
                    : ""
                }`}
              />
            )}
          />
          {errors?.cpfPercentage?.[index]?.employerPercentage && (
            <div className="invalid-feedback">
              {errors.cpfPercentage[index].employerPercentage.message}
            </div>
          )}
        </>
      ),
    },
    {
      title: "Total Percentage",
      dataIndex: "employerPercentage",
      width: 200,
      render: (_, __, index) => (
        <>
          <Controller
            name={`cpfPercentage[${index}].totalPercentage`}
            control={control}
            render={({ field }) => (
              <input
                {...field}
                type="text"
                placeholder="Total Percentage"
                className={`form-control ${
                  errors?.cpfPercentage?.[index]?.totalPercentage
                    ? "is-invalid"
                    : ""
                }`}
              />
            )}
          />
          {errors?.cpfPercentage?.[index]?.totalPercentage && (
            <div className="invalid-feedback">
              {errors.cpfPercentage[index].totalPercentage.message}
            </div>
          )}
        </>
      ),
    },
    {
      title: "Employee Percentage Max Ceiling",
      dataIndex: "employeeCpfMaxCeiling",
      width: 200,
      render: (_, __, index) => (
        <>
          <Controller
            name={`cpfPercentage[${index}].employeeCpfMaxCeiling`}
            control={control}
            render={({ field }) => (
              <input
                {...field}
                type="text"
                placeholder="Employee Percentage Salary Ceiling"
                className={`form-control ${
                  errors?.cpfPercentage?.[index]?.employeeCpfMaxCeiling
                    ? "is-invalid"
                    : ""
                }`}
              />
            )}
          />
          {errors?.cpfPercentage?.[index]?.employeeCpfMaxCeiling && (
            <div className="invalid-feedback">
              {errors.cpfPercentage[index].employeeCpfMaxCeiling.message}
            </div>
          )}
        </>
      ),
    },
    {
      title: "Total Cpf Max Ceiling",
      dataIndex: "totalCpfMaxCeiling",
      width: 200,
      render: (_, __, index) => (
        <>
          <Controller
            name={`cpfPercentage[${index}].totalCpfMaxCeiling`}
            control={control}
            render={({ field }) => (
              <input
                {...field}
                type="text"
                placeholder="Total Cpf Max Ceiling"
                className={`form-control ${
                  errors?.cpfPercentage?.[index]?.totalCpfMaxCeiling
                    ? "is-invalid"
                    : ""
                }`}
              />
            )}
          />
          {errors?.cpfPercentage?.[index]?.totalCpfMaxCeiling && (
            <div className="invalid-feedback">
              {errors.cpfPercentage[index].totalCpfMaxCeiling.message}
            </div>
          )}
        </>
      ),
    },
    {
      title: "Status",
      dataIndex: "isActive",
      width: 200,
      render: (_, __, index) => (
        <>
          <Controller
            name={`cpfPercentage[${index}].isActive`}
            control={control}
            defaultValue={watch(`cpfPercentage[${index}].isActive`)}
            render={({ field }) => (
              <Select
                {...field}
                options={activeStatusOptions}
                className={`select ${
                  errors?.cpfPercentage?.[index]?.isActive ? "is-invalid" : ""
                }`}
                value={contributionOptions.find(
                  (option) => option.value === field.value
                )}
                onChange={(selectedOption) => {
                  field.onChange(selectedOption ? selectedOption.value : "");
                }}
                menuPortalTarget={document.body}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    fontSize: "12px",
                    width: "100px",
                  }),
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
              />
            )}
          />
          {errors?.cpfPercentage?.[index]?.isActive && (
            <div className="invalid-feedback">
              {errors.cpfPercentage[index].isActive.message}
            </div>
          )}
        </>
      ),
    },
  ];
  if (isError) return <Error404 error={error} />;

  return (
    <div>
      <div className="toast-container position-fixed top-0 end-0 p-3">
        <ToastNotification
          showSuccessToast={showSuccessToast}
          showErrorToast={showErrorToast}
          message={message}
        />
      </div>
      <div className="page-wrapper">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="content">
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Add New CPF Percentage</h4>
                    <h6>Add your new cpf percengate details </h6>
                  </div>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">
                        Save CPF Percentage
                      </Tooltip>
                    }
                  >
                    <button type="submit" className="btn btn-added">
                      <Save className="me-2" />
                      Save
                    </button>
                  </OverlayTrigger>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
                  >
                    <Link
                      className="btn btn-secondary"
                      to={`${all_routes.master}${all_routes.cpfPercentage}`}
                    >
                      <i className="fa fa-reply me-2" />
                      Back
                    </Link>
                  </OverlayTrigger>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  {fields.length === 0 && isSubmitted && (
                    <AlertMessage
                      type="warning"
                      message="Please add atleast one row"
                    />
                  )}
                  <div className="card border-0">
                    <div className="card-header d-flex justify-content-between mb-3">
                      <h4 className="card-title">CPF Percentage</h4>
                      <button
                        type="button"
                        className="btn btn-success btn-sm"
                        onClick={addRowHandler}
                      >
                        <PlusCircle className="me-2" /> Add Row
                      </button>
                    </div>
                    <div className="card-body">
                      <div className="table-list-card">
                        <div className="">
                          <div className="table-responsive">
                            <Datatable
                              columns={columns}
                              dataSource={fields}
                              pagination={false}
                              rowKey="id"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default AddMultipleCPFPercentage;
